'use client';

import { useEffect } from 'react';

import { historyActions } from '../actions/history';

import { ContextStoreSearchSuggestion, storeSearchSuggestion } from './store';

interface ClientStoreSearchSuggestionProps {
  state: ContextStoreSearchSuggestion;
}

export function ClientStoreSearchSuggestion({
  state
}: ClientStoreSearchSuggestionProps) {
  useEffect(() => {
    storeSearchSuggestion.send({
      type: 'set',
      state
    });
    historyActions.init();
  }, [state]);

  return null;
}
